import _Layout from "@/components/_layout.front.vue";
import login from "@/components/common/page/login.vue";
import Page_404 from "@/components/common/page/404.vue";

import ODAVF000 from "@/components/page/F0/ODAVF000.vue";
import ODAVF101 from "@/components/page/F1/ODAVF101.vue";

import ODAVF100 from "@/components/page/F1/ODAVF100.vue";
import ODAVF102 from "@/components/page/F1/ODAVF102.vue";
import ODAVF103 from "@/components/page/F1/ODAVF103.vue";
import ODAVF109 from "@/components/page/F1/ODAVF109.vue";
import webContent from "@/components/page/F1/webContent.vue";

import ODAVFZ99 from "@/components/page/FZ/ODAVFZ99.vue";

// 後端至前端完整預覽
import fullPreview from "@/components/page/F0/fullPreview.vue";

import index from "@/components/page/index";

const routes = [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/index.html",
    redirect: "/index"
  },
  {
    path: "/page",
    name: "page",
    component: _Layout,
    children: [
      {
        path: "404",
        name: "Page_404",
        component: Page_404
      }
    ]
  },
  {
    path: "/",
    name: "root",
    component: _Layout,
    children: [
      {
        path: "index",
        name: "index",
        component: index
      },
      {
        path: "login",
        name: "login",
        component: login
      },
      // ODAV站內首頁 轉path
      {
        path: "home",
        name: "ODAVF000",
        component: ODAVF000
      },
      // 員工獎勵活動
      {
        path: "ODAVF100",
        name: "ODAVF100",
        component: ODAVF100
      },
      // 3、4月全站活動 轉path
      {
        path: "ODAVF102",
        name: "ODAVF102",
        component: ODAVF102
      },
      // 5、6月全站活動
      {
        path: "ODAVF103",
        name: "ODAVF103",
        component: ODAVF103
      },
      //20210305
      {
        path: "ODAVF109",
        name: "ODAVF109",
        component: ODAVF109
      },
      // 離開轉導頁面
      {
        path: "ODAVF101",
        name: "ODAVF101",
        component: ODAVF101
      },
      // 內容頁
      {
        path: "webContent",
        name: "webContent",
        component: webContent
      },
      // 完整預覽頁
      {
        path: "fullPreview",
        name: "fullPreview",
        component: fullPreview
      },
      // 內容頁-event
      {
        path: "event",
        name: "event",
        component: webContent
      }
    ]
  },
  {
    path: "/ODAVFZ99",
    name: "ODAVFZ99",
    component: ODAVFZ99
  }
];

export default {
  routes
};
